import { FilterFn, RowData, SortingFn } from '@tanstack/react-table';

declare module '@tanstack/react-table' {
  interface ColumnMeta<TData extends RowData, TValue> {
    sortIcon?: 'string' | 'number'; // extending the column metadata to include the type of icon to use when sorting
  }
}

export const includedInArr: FilterFn<any> = (row, columnId, filterValue: string[]) => {
  if (!filterValue || filterValue.length === 0) return true;
  const cellValue = row.getValue<string>(columnId);
  return filterValue.includes(cellValue);
};

export const arrInArr: FilterFn<any> = (row, columnId, filterValue: string[]) => {
  if (!filterValue || filterValue.length === 0) return true;
  const cellValue = row.getValue<string[]>(columnId);
  return cellValue.some((value) => filterValue.includes(value));
};

// global filter for selected rows
export const selectedRowsFilter: FilterFn<any> = (row, _columnId, filterValue) => {
  if (!filterValue) return true;
  return row.getIsSelected();
};

// custom sorting function to put empty/falsy values last
export const sortStringWithEmptyLast: SortingFn<any> = (rowA, rowB, columnId) => {
  const a = rowA.getValue<string>(columnId);
  const b = rowB.getValue<string>(columnId);

  // If both are falsy, they're equal
  if (!a && !b) return 0;
  // If only a is falsy, b comes first
  if (!a) return 1;
  // If only b is falsy, a comes first
  if (!b) return -1;

  // Both have values, do normal string comparison
  return a.localeCompare(b);
};

export const sortArrayLength: SortingFn<any> = (rowA, rowB, columnId) => {
  const a = rowA.getValue<unknown[]>(columnId);
  const b = rowB.getValue<unknown[]>(columnId);
  return a.length > b.length ? 1 : a.length < b.length ? -1 : 0;
};
